export const GET_Menu_OPTIONS = 'GET_Menu_OPTIONS';
export const GET_Menu_OPTIONS_SUCCESS = 'GET_Menu_OPTIONS_SUCCESS';
export const GET_Menu_OPTIONS_FAIL = 'GET_Menu_OPTIONS_FAIL';
